module.exports = __webpack_public_path__ + "img/2.e82f2911.png";